import { render, staticRenderFns } from "./RedList.vue?vue&type=template&id=5475ef56&"
import script from "./RedList.vue?vue&type=script&lang=js&"
export * from "./RedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
